// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__J-85z","title":"ClientInsurance_title__1-d3l","itemText":"ClientInsurance_itemText__W5r5u"};